<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-bread`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38 4a8 8 0 014 14.93V42a2 2 0 01-2 2H8a2 2 0 01-2-2V18.93A8 8 0 0110 4h28zm0 4H10a4 4 0 00-1.997 7.467L10 16.623V40h28V16.623l1.997-1.156A4 4 0 0038 8zm-3 13v16h-4V21h4z"/></svg>
</template>
<script>

export default {
  name: 'IconBread',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
